import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components';
import { FolderType, RolesAssignment, } from '@models';
import { FoldersService } from '@services';
import { addToArrayIf, addToObjectIf, } from '@utils/object.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, of, Subject, } from 'rxjs';
import { startWith, switchMap, takeUntil, } from 'rxjs/operators';
var UpsertFolderModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UpsertFolderModalComponent, _super);
    function UpsertFolderModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.FolderType = FolderType;
        _this.RolesAssignment = RolesAssignment;
        _this.loading$ = new BehaviorSubject(false);
        _this._foldersService = _this._injector.get(FoldersService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this._destroyed$ = new Subject();
        _this._submitPayload = function (payload) {
            _this.loading$.next(true);
            if (_this.isNewEntry) {
                _this._foldersService
                    .add(payload)
                    .subscribe(function (folder) {
                    _this._dialogRef.close({
                        type: 1 /* Add */,
                        data: {
                            current: folder,
                        },
                    });
                }, function () {
                    _this.loading$.next(false);
                });
                return;
            }
            payload.id = _this.context.data.current.id;
            var isAppStateFolder = _this._appState.user.folder.hasAny &&
                _this.context.data.current.id === _this._appState.user.folder.value.id;
            _this._foldersService
                .update(payload.id, payload)
                .pipe(switchMap(function (resp) {
                return isAppStateFolder
                    ? _this._appState.user.folder.fetch()
                    : of(resp);
            }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 2 /* Update */,
                    data: {
                        current: payload,
                    },
                });
            }, function (error) {
                _this.loading$.next(false);
                if (error.status === 404) {
                    _this._dialogRef.close({
                        type: 5 /* Failed */,
                        additionalData: error,
                    });
                }
            });
        };
        return _this;
    }
    Object.defineProperty(UpsertFolderModalComponent.prototype, "isRoot", {
        get: function () {
            return this.context.data.parent === null ||
                !!this.context.data.current && this.context.data.current.parentId === null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertFolderModalComponent.prototype, "isNewEntry", {
        get: function () {
            return !this.context.data.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertFolderModalComponent.prototype, "showRolesAssignmentOption", {
        get: function () {
            return this.isNewEntry ||
                this.context.data.current.type === FolderType.Modern;
        },
        enumerable: true,
        configurable: true
    });
    UpsertFolderModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hasRolesAssignment = !!this.context.data.current && !!this.context.data.current.rolesAssignment;
        var parentId = !!this.context.data.parent && this.context.data.parent.id ||
            !!this.context.data.current && this.context.data.current.parentId;
        var showTypeOption = this.isRoot || hasRolesAssignment;
        var defaultType = this._appState.settings.get(Setting.isModernFolderSystemEnabled) ?
            FolderType.Modern :
            FolderType.Classic;
        var type = this.context.data.current &&
            this.context.data.current.type ||
            defaultType;
        var controls = tslib_1.__assign({}, addToObjectIf(!!parentId, { 'parentId': [parentId] }), addToObjectIf(showTypeOption, {
            'type': [
                type
            ].concat(addToArrayIf(this.isNewEntry, Validators.required)),
        }), addToObjectIf(this.showRolesAssignmentOption || hasRolesAssignment, {
            'rolesAssignment': [
                {
                    value: this.context.data.current && this.context.data.current.rolesAssignment ||
                        this.context.data.parent && this.context.data.parent.rolesAssignment ||
                        RolesAssignment.CustomRoles,
                    disabled: (this.context.data.current && this.context.data.current.type === FolderType.Classic) ||
                        !this.isRoot ||
                        !this.isNewEntry,
                }
            ].concat(addToArrayIf(this.isNewEntry, Validators.required)),
        }), { 'displayName': [
                this.context.data.current && this.context.data.current.displayName,
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(115),
                ]),
            ], 'description': [
                this.context.data.current && this.context.data.current.description,
                Validators.maxLength(500),
            ] });
        this.form = this._injector.get(FormBuilder).group(controls);
        if (showTypeOption) {
            this.form.get('type')
                .valueChanges
                .pipe(startWith(type), takeUntil(this._destroyed$))
                .subscribe(function () {
                var rawValue = _this.form.getRawValue();
                if (!!rawValue.rolesAssignment) {
                    var rolesControl = _this.form.get('rolesAssignment');
                    if (rawValue.type === FolderType.Classic) {
                        rolesControl.setValue(RolesAssignment.InheritFromTenant);
                        rolesControl.disable();
                    }
                    else {
                        rolesControl.enable();
                    }
                }
            });
        }
    };
    UpsertFolderModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UpsertFolderModalComponent.prototype.onSubmit = function () {
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        this._submitPayload(cloneDeep(this.form.getRawValue()));
    };
    return UpsertFolderModalComponent;
}(UiModalComponent));
export { UpsertFolderModalComponent };
